/*
 * Themes for use for layout within our Slats.
 */

export const LandingPageSlat = {
  mobile: {
    contentStyles: {
      padding: '1.5rem 1rem 2rem',
    },
  },
  desktop: {
    contentStyles: {
      padding: '4.5rem 1.5rem 5rem',
    },
  },
};

export const VibeSlat = {
  mobile: {
    contentStyles: {
      padding: '1.5rem 1rem 2rem',
    },
    mediaStyles: {
      padding: '2rem 1rem',
    },
  },
  desktop: {
    contentStyles: {
      padding: '0 2rem 0 0',
    },
    mediaStyles: {
      padding: '4.25rem 2.5rem',
    },
  },
};

export const LandingPageVideoSlat = {
  mobile: {
    contentStyles: {
      padding: '1.5rem 1rem 2rem',
    },
    mediaStyles: {
      padding: '0',
    },
  },
  desktop: {
    contentStyles: {
      padding: '0 3.5rem',
    },
    mediaStyles: {
      padding: '4.25rem 2.5rem 4.25rem 1.25rem',
    },
  },
};

export const CrossSellTheme = {
  mobile: {
    contentStyles: {
      padding: '1rem 0',
    },
    mediaStyles: {
      padding: '0',
    },
  },
  desktop: {
    contentStyles: {
      padding: '2rem 0',
    },
    mediaStyles: {
      padding: '0',
    },
  },
};

export const PromoBannerTheme = {
  mobile: {
    contentStyles: {
      padding: 0,
    },
  },
  desktop: {
    contentStyles: {
      padding: '4.5rem 1.5rem 5rem',
    },
  },
};

export const BlankBannerTheme = {
  mobile: {
    contentStyles: {
      padding: '2rem 1.5rem 1.5rem',
    },
  },
  desktop: {
    contentStyles: {
      padding: '3rem 0 1.5rem',
    },
  },
};

export const FlyerPageMidBannerTheme = {
  mobile: {
    contentStyles: {
      padding: '2rem 1rem 1rem',
    },
  },
  desktop: {
    contentStyles: {
      padding: '4.5rem 1.5rem 5rem',
      height: '100%',
    },
  },
};

export const SlatThemes = {
  default: LandingPageSlat,
  LandingPageSlat,
  VibeSlat,
  LandingPageVideoSlat,
  CrossSellTheme,
  PromoBannerTheme,
  BlankBannerTheme,
  FlyerPageMidBannerTheme,
};

export default SlatThemes;
